import type {
  ServerPrivateError,
  ServerPublicError,
  ServerParamsError,
  ServerUnknownError,
  ServerLegacyError,
  ServerError
} from './types';

function isPrivateError(error: ServerError): error is ServerPrivateError {
  return !!(error as ServerPrivateError).type && !!(error as ServerPrivateError).private;
}

function isPublicError(error: ServerError): error is ServerPublicError {
  return !!(error as ServerPublicError).type && !(error as any).private;
}

function isParamsError(error: ServerError): error is ServerParamsError {
  return error.error === 'bad_parameters';
}

function isUnknownError(error: ServerError): error is ServerUnknownError {
  return error.error === 'unknown';
}

function isLegacyError(error: ServerError): error is ServerLegacyError {
  return (
    !isPrivateError(error) &&
    !isPublicError(error) &&
    !isParamsError(error) &&
    !isUnknownError(error)
  );
}

export { isPrivateError, isPublicError, isParamsError, isUnknownError, isLegacyError };
